import React from "react";
import {Select as MuiSelect, SelectProps} from "@mui/material";

export type SelectType = SelectProps & {
  fullWidth?: boolean;
};
export const Select = React.forwardRef<HTMLDivElement, SelectType>(({fullWidth, children, sx, ...props}, ref) => {
  return (
    <MuiSelect
      ref={ref}
      sx={{
        borderRadius: "8px",
        width: fullWidth ? "100%" : "auto",
        ...sx,
      }}
      {...props}
    >
      {children}
    </MuiSelect>
  );
});

Select.displayName = "Select";
